export default __webpack_public_path__ + "static/media/im-icon-active.e8677f52.svg";